<template>
  <div class="league-assistant">
    <a-row type="flex">
      <a-col flex="230px">
        <div class="flex-between">
          <span class="title-2">团辅方案</span>
          <a-button type="primary" size="small" @click="createLeague">创建</a-button>
        </div>
        <div>
          <a-directory-tree
            multiple
            default-expand-all
            :selectedKeys="selectedKeys"
            @select="onSelect"
            @expand="onExpand"
          >
            <a-tree-node v-for="item in treeData" :key="item.key">
              <template slot="title">
                <span style="margin-right: 20px">{{ item.title }}</span>
                <a-icon
                  type="edit"
                  :style="{ fontSize: '16px', color: '#1783E8' }"
                  @click.stop="editLeague(item)"
                />
              </template>
              <!--              <a-tree-node-->
              <!--                v-for="child in item.children"-->
              <!--                :key="child.key"-->
              <!--                :title="child.title"-->
              <!--                is-leaf-->
              <!--              />-->
            </a-tree-node>
          </a-directory-tree>
        </div>
      </a-col>
      <a-col flex="2px">
        <a-divider type="vertical" style="height: 400px" />
      </a-col>
      <a-col flex="auto">
        <div v-html="currContent" style="margin-left: 10px"></div>
      </a-col>
    </a-row>
    <CreateLeagueModal ref="createLeagueModalRef" @refreshData="getTeamAssistant" />
  </div>
</template>

<script>
import CreateLeagueModal from './components/CreateLeagueModal'
import { getAction } from '@api/manage'

export default {
  name: 'TeamAssistant',
  components: {
    CreateLeagueModal,
  },
  data() {
    return {
      selectedKeys: [],
      treeData: [
        {
          title: '新生适应',
          key: '0',
          children: [
            {
              title: '新生入学',
              key: '0-0',
            },
            {
              title: '入学前准备',
              key: '0-1',
            },
            {
              title: '课余生活',
              key: '0-2',
            },
            {
              title: '课外活动',
              key: '0-3',
            },
            {
              title: '课外活动',
              key: '0-4',
            },
          ],
        },
        {
          title: '考试焦虑',
          key: '1',
        },
        {
          title: '校园欺凌',
          key: '2',
          children: [
            {
              title: '校园霸凌',
              key: '2-0',
            },
          ],
        },
        {
          title: '亲子关系',
          key: '3',
        },
        {
          title: '学习动力',
          key: '4',
        },
        {
          title: '情绪管理',
          key: '5',
        },
        {
          title: '网络成瘾',
          key: '6',
        },
      ],
      pageNo: 1,
      pageSize: 10,
      currContent: '',
    }
  },
  created() {
    this.getTeamAssistant()
  },
  methods: {
    onSelect(keys) {
      this.selectedKeys = keys
      const nodeItem = this.treeData.find((item) => item.key === keys[0])
      this.currContent = nodeItem?.content || ''
    },
    onExpand() {
      console.log('Trigger Expand')
    },
    createLeague() {
      this.$refs.createLeagueModalRef.showModal()
    },
    editLeague(item) {
      this.$refs.createLeagueModalRef.showModal(item)
    },
    async getTeamAssistant() {
      const res = await getAction('/resourceGroupCounseling/list', {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
      })
      this.treeData = res.result.records.map((item) => ({
        ...item,
        key: item.id,
      }))
      this.selectedKeys = [this.treeData[0].key]
      const nodeItem = this.treeData.find((item) => item.key === this.selectedKeys[0])
      this.currContent = nodeItem?.content || ''
      // console.log('团辅方案：', res)
    },
  },
}
</script>
<style scoped lang="less">
.league-assistant {
  /deep/ .ant-tree-treenode-selected .ant-tree-switcher-icon {
    color: #1783e8 !important;
  }
  /deep/ .ant-tree-node-selected {
    color: #1783e8 !important;
    &::before {
      background: #eaf5ff !important;
    }
  }
}
</style>
